// @flow

import type {
  AllVideosModel,
  VideoModel,
  VideoTopicModel,
  VideoPlaylistModel,
  VideoTopicOrVideoModel,
} from './Videos';

export type VideosResolvers = {|
  getVideo: (videoId: string) => VideoModel | null,
  getTopic: (topicId: string) => VideoTopicModel | null,
  getPlaylist: (playlistId: string) => VideoPlaylistModel | null,
  getAll: () => AllVideosModel | null,

  getVideoOrTopic: (props: {
    videoId?: string,
    topicId?: string,
  }) => VideoTopicOrVideoModel | null,
|};

export const createResolvers = (model?: AllVideosModel): VideosResolvers => {
  return {
    getVideo(videoId: string): VideoModel | null {
      if (!model) {
        return null;
      }

      return model.videos[videoId];
    },
    getTopic(topicId: string): VideoTopicModel | null {
      if (!model) {
        return null;
      }

      return model.topics[topicId];
    },
    getPlaylist(playlistId: string): VideoPlaylistModel | null {
      if (!model) {
        return null;
      }

      return model.playlists[playlistId];
    },
    getAll(): AllVideosModel | null {
      if (!model) {
        return null;
      }

      return model;
    },
    getVideoOrTopic(props: {
      videoId?: string,
      topicId?: string,
    }): VideoTopicOrVideoModel | null {
      if (!model) {
        return null;
      }

      if (props.videoId) {
        return this.getVideo(props.videoId);
      } else if (props.topicId) {
        return this.getTopic(props.topicId);
      } else {
        return null;
      }
    },
  };
};
